import React from 'react';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { classNamesFunction, Text } from '@fluentui/react';
import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { ICredentialDialogStyles, styles } from './CredentialDialog.styles';
import { CopyButton } from '../../shared/CopyButton';

interface ICopyLinkDialogProps {
  onBack: () => void;
  onDone: () => void;
  link: string;
}

const getClassNames = classNamesFunction<{}, ICredentialDialogStyles>();
export const CopyLinkDialog: React.FunctionComponent<ICopyLinkDialogProps> = ({ onBack, onDone, link }) => {
  const [t] = useLocalization('Account');

  const classNames = getClassNames(styles);

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        type: DialogType.normal,
        showCloseButton: false,
      }}
      modalProps={{ isBlocking: true, styles: { main: styles.main } }}
    >
      <div className={classNames.content}>
        <Text className={classNames.description}>{t('copyLinkDescription')}</Text>
        <Text>
          <Text className={classNames.description}>URL: </Text>
          {link}
          <CopyButton text={t('copy')} copiedText={t('copied')} value={link} />
        </Text>
      </div>
      <DialogFooter>
        <DefaultButton onClick={onBack} text={t('back')} />
        <PrimaryButton onClick={onDone} text={t('done')} />
      </DialogFooter>
    </Dialog>
  );
};
